import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '@/context';

const ServiceSupport: React.FC<{ childRef }> = ({ childRef }) => {
  const searchParamsString = window.location.href.split('?')[1] || '';
  const searchParams = new URLSearchParams(searchParamsString);
  searchParams.delete('y');
  const navigate = useNavigate();
  const {
    userInfo,
    setContextValue
  } = useContext(DataContext);
  return (
    <section className="bg-black py-16 md:py-24 px-4 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-8 md:mb-16"
        >
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">
            这还不算完！
          </h2>
          <p className="text-sm md:text-xl text-gray-500">
            保姆式服务，助你又快又好完成每个商单！
          </p>
        </motion.div>

        <div className="grid grid-cols-2 gap-3 md:gap-8 mb-12 md:mb-16">
          {/* Card 1: AI Support */}
          <motion.div
            whileHover={{ scale: 1.01 }}
            className="group relative rounded-2xl md:rounded-[2rem] overflow-hidden bg-[#080808] border border-white/10 !h-max"
          >
            <div className="absolute inset-0 bg-gradient-to-b from-blue-900/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 !h-max" />
            <div className="p-6 md:p-14 relative z-10 flex flex-col h-full justify-center min-h-[140px] md:min-h-[140px]">
              <h3 className="text-sm md:text-2xl font-bold text-white mb-2 md:mb-4">AI 加持</h3>
              <p className="text-gray-400 text-[10px] md:text-lg leading-relaxed">
                世界500强企业都在用的AI设计神器，<br className="hidden md:block" />
                <span className="text-blue-400">AI生图 + 修图一站式搞定</span>。
              </p>
            </div>
          </motion.div>

          {/* Card 2: Training */}
          <motion.div
            whileHover={{ scale: 1.01 }}
            className="group relative rounded-2xl md:rounded-[2rem] overflow-hidden bg-[#080808] border border-white/10 !h-max"
          >
            <div className="absolute inset-0 bg-gradient-to-b from-purple-900/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 !h-max" />
            <div className="p-6 md:p-14 relative z-10 flex flex-col h-full justify-center min-h-[140px] md:min-h-[140px]">
              <h3 className="text-sm md:text-2xl font-bold text-white mb-2 md:mb-4">商单训练营</h3>
              <p className="text-gray-400 text-[10px] md:text-lg leading-relaxed">
                每天商单作图技巧直播 + 私域社群实时答疑，<br className="hidden md:block" />
                让你轻松进阶 <span className="text-purple-400">AI设计大师</span>。
              </p>
            </div>
          </motion.div>
        </div>

        <div className="flex justify-center">
          <button className="group relative px-6 py-3 md:px-10 md:py-5 bg-white text-black rounded-full text-base md:text-xl font-bold hover:bg-gray-100 transition-all shadow-[0_0_40px_rgba(255,255,255,0.15)] flex items-center gap-2 md:gap-3"
            onClick={() => {
              if (!(userInfo?.user_id === 0 || userInfo?.user_id)) {
                childRef?.current?.openLogin?.()
                return
              }
              navigate({ pathname: '/', search: '?' + searchParams.toString() });
              // setIsModalOpen(true)
            }}>
            试用AI设计工具
            <ArrowRight className="w-4 h-4 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServiceSupport;